export enum DemandStatus {
  NOVO = 'NOVO',
  EM_PROGRESSO = 'EM_PROGRESSO',
  CONCLUIDO = 'CONCLUIDO',
  ENTREGUE = 'ENTREGUE',
}
